module.exports = __webpack_public_path__ + "static/color_logo-6c2b8f4f8cc11015fa88849eab04e6fc.png";